import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

ReactDOM.render("", document.getElementsByTagName("title")[0]);
ReactDOM.render(<App />, document.getElementById("root"));